import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const red = '#bb0000';
const grey ='#a2afb9';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    fontSize: 20,
    textAlign:'center',
    backgroundColor:red,
    color:'#ffffff'
  },
  input: {
    display: 'none',
  },
});
class AnswerButton extends Component {
  handleOnClick = () => {
    this.props.clickFunc()
  }

  render(){
  const { classes } = this.props;
  return (
    <div>
      <Button
        onClick={this.handleOnClick}
        variant="contained"
        color={grey}
        className={classes.button}
      >
        back
      </Button>
    </div>
  );
}
}


AnswerButton.propTypes = {
  classes: PropTypes.object.isRequired,
  clickFunc: PropTypes.func.isRequired
};

export default withStyles(styles)(AnswerButton);



// WEBPACK FOOTER //
// ./src/components/quiz/QuizButtons/BackButton.js